import { useAppDispatch, useAppSelector, useHandlePageNavigate } from "./hooks";
import { selectPropertyReportStatus } from "../features/reports/reportsSlice";
import { useLocation } from "react-router-dom";
import { setPreForeclosureSearch } from "../features/multisearch/multisearchSlice";
import React from "react";
import { sendMemberEventAsync } from "../features/admin/adminSlice";

export type PullPropertyReportParams = any;

type UsePreForclosureSearch = () => (
  report: PullPropertyReportParams,
  pullLocation: string,
) => void;

/* PreForeclosure Search */
const usePreForeclosureSearchDispatch: UsePreForclosureSearch = () => {
  const dispatch = useAppDispatch();
  const propertyReportStatus = useAppSelector(selectPropertyReportStatus);
  const pageNavigate = useHandlePageNavigate();
  const location = useLocation();

  const pullPreForeclosure = React.useCallback(
    (report: PullPropertyReportParams, pullLocation: string) => {
      if (propertyReportStatus === "loading") return;
      if (location.pathname !== "/market-search") {
        pageNavigate("/market-search");
      } else {
        window.scrollTo(0, 0);
      }

      const dto = {
        addressLine1: report.streetNumber
          ? report.streetNumber + " " + report.streetName
          : report.fullStreetAddress
            ? report.fullStreetAddress
            : report.addressLine1
              ? report.addressLine1
              : report.streetName,
        addressLine2: report.subPremise
          ? report.subPremise
          : report.addressLine2,
        state: report.state,
        city: report.city,
        zip: report.zip,
        latitude: report.lat
          ? report.lat
          : report.latitude
            ? report.latitude
            : undefined,
        longitude: report.long
          ? report.long
          : report.longitude
            ? report.longitude
            : undefined,
        nearbySchoolRadius: report.nearbySchoolRadius
          ? report.nearbySchoolRadius
          : 5,
        propertyId: report.propertyId, // Optional property ID for FA data
        addressComponents: {
          streetNumber: report.streetNumber,
          streetName: report.streetName,
          subPremise: report.subPremise,
          zip4: report.zip4,
          county: report.county,
          neighborhood: report.neighborhood,
          sublocality: report.sublocality,
          premise: report.premise,
          floor: report.floor,
          establishment: report.establishment,
        },
      };
      dispatch(setPreForeclosureSearch(dto));
      dispatch(
        sendMemberEventAsync({
          EventAction: "Search",
          EventCategory: "Foreclosure",
          MetaData: JSON.stringify({ "pull location": pullLocation }),
        }),
      );
    },
    [dispatch, propertyReportStatus, pageNavigate, location],
  );

  return pullPreForeclosure;
};

export { usePreForeclosureSearchDispatch };
